import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

import favicon from '../../theme/img/webp/favicon.webp'

const drawerWidth = 240;
const navItems = [
  { title: "Home Page", src: "/" },
  { title: "About us", src: "/about" },
  { title: "Disclaimer", src: "/disclaimer" },
];

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ m: 0 }}>
        <Link to={navItems[0].src} className="nav-link" relative="path">
          <Typography sx={{ color: "#111", textDecoration: "none" }}>
            <img width='35' src={favicon} alt='icon'/>
          </Typography>
        </Link>
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item?.title} disablePadding>
            <Link to={item?.src} className="nav-link" relative="path">
              <Typography sx={{ color: "#111", textDecoration: "none", textTransform: 'capitalize' }}>
                {item?.title}
              </Typography>
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar component="nav" sx={{background: '#818181', color: 'black', boxShadow: 'none', borderBottomLeftRadius: '2em', borderBottomRightRadius: '2em', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: { xs: "right", sm: "center" }}}>
        <Toolbar sx={{ position: "relative" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            <Link to={navItems[0].src} relative="path">
              <Typography sx={{ color: "#fff", textDecoration: "none" }}>
                <img width='50' src={favicon} alt='icon'/>
              </Typography>
            </Link>
          </Typography>
          <Box sx={{ display: { xs: "none", sm: "block" }, m: '0 2em' }}>
            {navItems.map((item) => (
              <Button key={item.title} sx={{ color: "#fff" }}>
                <Link to={item?.src} className="nav-link" relative="path">
                  <Typography sx={{ color: "#111", fontWeight: 700, textDecoration: "none" }}>
                    {item?.title}
                  </Typography>
                </Link>
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBar;
